<template>
  <!--
    <ParseForm :formParams='formParams' formId='dataBusiness' :opCode='opCode' ref='bus'></ParseForm>
  -->
  <div>
    <template>
      <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>环境选择:</div>
          <div class="input-group">
            <ejs-dropdownlist id="environment" :fields = "fields" :index = "currentIndex" :dataSource = "envItems" :popupHeight= "popupHeight" v-model='environment'>
            </ejs-dropdownlist>
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>实例名称:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']">
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>实例描述:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']">
          </div>
        </div>
      </div>
    </template>
    <SubTabs :elements="getTabElements" :styles='tabs.styles'>
      <template v-slot:tabsContent>
        <!-- <div style="margin-top: 15px;">
           <ParseForm :formParams='formParams[0].resultVal' :emit='emit' formId='chartBusiness' opCode='add' ref='bus' ></ParseForm>
         </div>-->
        <div v-if='hackReset' v-for="dataItem in getFormParam">
          <div style="margin-top: 15px;">
            <ParseForm :formParams='dataItem.resultVal' :emit='emit' :formId='dataItem.key' opCode='add' ref='bus' ></ParseForm>
          </div>
        </div>
        <div style="margin-top: 15px;">
          <!--
                    <VideoBusiness :formParams='formParamsVideo' ref="video" :info='videoBusinessInfo' :gmsInfo='videoBusinessInfoGroup' :opCode="opCode"></VideoBusiness>
          -->
        </div>
      </template>
    </SubTabs>
  </div>
</template>
<script>
  import ParseForm from '../../subscriberconfig/util/parseFormNew/ParseForm';
  import SubTabs from '../../subscriberconfig/util/SubTabs';
  import commonJs from '../../subscriberconfig/mcsSubscriber/common';
  import bus from '../../subscriberconfig/mcsSubscriber/user/bus';
  import { EventBus } from '../../../plugins/eventBus';

  export default {
    name: 'SingleDeployment',
    components: {
      ParseForm,
      SubTabs
    },
    props: [
      'formParams',
      'opCode',
      'tabElements'
    ],
    mixins: [commonJs],
    data() {
      return {
        hackReset: true,
        fields: { text: 'name', value: 'id' },
        popupHeight: 200,
        currentIndex: 0,
        environment: 0,
        envItems: [],
        funcKeyUpMap: '',
        funcMap: new Map(),
        tabs: {
          styles: {
            heightMode: 'Auto'
          }
        },
        page: {
          pageNo: 1,
          pageSize: 100,
          totalCount: 0,
          pageCount: 0
        }
      };
    },
    methods: {
      getEnvironments(type) {
        const $this = this;
        this.$axios.post('/lte/ems/env/getEnvironmentList.html', {
          type: type,
          page: {
            pageNo: $this.page.pageNo,
            pageSize: $this.page.pageSize
          }
        }).then((response) => {
          const res = response.data.resultVal;
          if (response.status === 200 && res !== null) {
            $this.envItems = res.result;

            // EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
          } else {
            EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
          }
        });
      },
      emit(attr) {
        bus.$emit('eventBus', attr);
      }
    },
    computed: {
      getFormParam() {
        return this.formParams;
      },
      getTabElements() {
        return this.tabElements;
      }
    },
    mounted: {

    }
  };
</script>
